module.exports = __webpack_public_path__ + "img/judge-1.b2130375.png";